import { FormGroup } from "@angular/forms";

export class CustomValidators{
    
    static DateLessThan(from: string, to: string) {
        return (group: FormGroup): {[key: string]: any} => {
         let f = group.controls[from];
         let t = group.controls[to];
         if (f.value > t.value) {
           return {
             dates: "Date from should be less than Date to"
           };
         }
         return {};
        }
      }
}